(() => {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5b74"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5b74"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("0O13J", function(module, exports) {

var $gbMqE = parcelRequire("gbMqE");

var $4hQzZ = parcelRequire("4hQzZ");

var $fSvBw = parcelRequire("fSvBw");

var $g3aVv = parcelRequire("g3aVv");
if (module.hot) module.hot.accept();
const url = new URL(window.location.href);
const MOBILE_BREAKPOINT = 620;
const windowPathname = url.pathname;
// Check the pathname to see if it includes any of the excluded paths:
const excludedPaths = [
    "find-specialist",
    "sign-up",
    "choosing-fertility-treatment",
    "about-details-ivf"
];
const excludedPath = excludedPaths.find((path)=>{
    return windowPathname.includes(path);
});
if (Boolean(excludedPath)) return;
// create stylesheet link tag for main.css:
const handleLoadingCSS = async ()=>{
    try {
        const scriptSrc = document.getElementById("sign-up-widget")?.src || null;
        if (!scriptSrc) {
            console.error("missing script id");
            return;
        }
        const src = new URL(scriptSrc);
        const baseURI = src.origin;
        const linkTagHref = `${baseURI}/main.css`;
        const linkTag = document.createElement("link");
        linkTag.rel = "stylesheet";
        linkTag.type = "text/css";
        linkTag.href = linkTagHref;
        document.head.appendChild(linkTag);
        const isCSSLoaded = await new Promise((resolve, reject)=>{
            linkTag.onload = ()=>{
                resolve(true);
            };
            linkTag.onerror = (error)=>{
                reject(error);
            };
        });
        return isCSSLoaded;
    } catch (error) {
        console.error("failed to fetch main.css", error);
        return false;
    }
};
const handleCreateElement = ({ parentContainer, tag, innerHTML, classList, eventListener, ...rest })=>{
    const element = document.createElement(tag);
    classList?.split(" ").forEach((className)=>element.classList.add($g3aVv[className]));
    parentContainer?.appendChild(element) || document.body.appendChild(element);
    element.innerHTML = innerHTML || "";
    Object.keys(rest).forEach((key)=>{
        element[key] = rest[key];
    });
    return element;
};
const handleRemoveElement = (element)=>{
    element.remove();
};
const createIFrameContainerContent = ({ parentContainer })=>{
    const url = new URL(window.location.href);
    const origin = url.origin;
    const environment = url.searchParams.get("environment");
    let iFrameBaseUrl = "";
    switch(environment){
        case "development":
            iFrameBaseUrl = "http://localhost:3400";
            break;
        case "staging":
            iFrameBaseUrl = "https://fertility-outreach-staging.herokuapp.com";
            break;
        case "production":
            iFrameBaseUrl = "https://fertilityapp.fertilityoutloud.com";
            break;
        default:
            iFrameBaseUrl = "https://fertilityapp.fertilityoutloud.com";
            break;
    }
    let iFrameParams = `?signup_source=fol&signup_url=${origin}`;
    const windowParams = url.search || "";
    if (windowParams) // remove the "?" from the window params
    url.searchParams.forEach((value, key)=>{
        if (key === "environment") return;
        return iFrameParams += `&${key}=${value}`;
    });
    const iFrame = handleCreateElement({
        tag: "iframe",
        src: `${iFrameBaseUrl}/sign-up${iFrameParams}`,
        width: "100%",
        height: "100%",
        loading: "eager",
        frameBorder: 0,
        parentContainer: parentContainer
    });
    // TODO: Add event listener to close the widget from inside the iframe
    return iFrame;
};
const handleGetSessionStorage = (key)=>{
    return sessionStorage.getItem(key);
};
const handleSetSessionStorage = (key, value)=>{
    sessionStorage.setItem(key, value);
};
// APP STARTS HERE: FOL WIDGET
const initializeFOLWidget = async ()=>{
    const widgetStatus = handleGetSessionStorage("widgetStatus");
    if (widgetStatus === "closed") return;
    // PARENT CONTAINER:
    const widgetContainer = handleCreateElement({
        tag: "div",
        classList: "fol-widget hidden",
        id: "fol-widget",
        parentContainer: document.body
    });
    const buttonContainer = handleCreateElement({
        parentContainer: widgetContainer,
        tag: "div",
        classList: "button-container"
    });
    // Text Container:
    handleCreateElement({
        parentContainer: buttonContainer,
        tag: "div",
        classList: "button-text-container",
        innerHTML: `<span class=${$g3aVv["font-regular"]}>TEXT WITH A</span> <span class=${$g3aVv["font-bold"]}>FERTILITY COACH</span>`
    });
    const hideWidgetButton = handleCreateElement({
        parentContainer: widgetContainer,
        tag: "div",
        classList: "hide-widget-button-container",
        innerHTML: (0, (/*@__PURE__*/$parcel$interopDefault($fSvBw)))
    });
    const iconContainer = handleCreateElement({
        parentContainer: buttonContainer,
        tag: "div",
        classList: "icon",
        innerHTML: (0, (/*@__PURE__*/$parcel$interopDefault($gbMqE)))
    });
    const iFrameContainer = handleCreateElement({
        parentContainer: widgetContainer,
        tag: "div",
        classList: "iframe-container loading"
    });
    const iFrameContainerContent = createIFrameContainerContent({
        parentContainer: iFrameContainer
    });
    const closeWidgetIconSvg = (0, (/*@__PURE__*/$parcel$interopDefault($fSvBw)));
    const closeIcon = handleCreateElement({
        parentContainer: iFrameContainer,
        tag: "div",
        classList: "close-widget-icon",
        innerHTML: closeWidgetIconSvg
    });
    let backgroundContainer = HTMLElement;
    const handleWidgetOpen = ()=>{
        iconContainer.innerHTML = (0, (/*@__PURE__*/$parcel$interopDefault($4hQzZ)));
        backgroundContainer = handleCreateElement({
            tag: "div",
            classList: "background-container",
            parentContainer: document.body,
            innerHTML: ""
        });
        iFrameContainer.classList.remove($g3aVv["hidden"]);
        iFrameContainer.classList.remove($g3aVv["loading"]);
        buttonContainer.removeEventListener("click", handleWidgetOpen);
        buttonContainer.addEventListener("click", handleWidgetClose);
        closeIcon.addEventListener("click", handleWidgetClose);
        backgroundContainer.addEventListener("click", handleWidgetClose);
        widgetContainer.style.zIndex = 1000;
        backgroundContainer.style.zIndex = 999;
        if (window.innerWidth <= MOBILE_BREAKPOINT) document.body.style.overflow = "hidden";
    };
    const handleWidgetClose = ()=>{
        widgetContainer.removeAttribute("style");
        backgroundContainer.removeAttribute("style");
        document.body.removeAttribute("style");
        iconContainer.innerHTML = (0, (/*@__PURE__*/$parcel$interopDefault($gbMqE)));
        handleRemoveElement(backgroundContainer);
        iFrameContainer.classList.add($g3aVv["hidden"]);
        closeIcon.removeEventListener("click", handleWidgetClose);
        buttonContainer.removeEventListener("click", handleWidgetClose);
        buttonContainer.addEventListener("click", handleWidgetOpen);
    };
    const hideWidget = (e)=>{
        handleSetSessionStorage("widgetStatus", "closed");
        widgetContainer.remove();
    };
    hideWidgetButton.addEventListener("click", hideWidget);
    buttonContainer.addEventListener("click", handleWidgetOpen);
};
const renderFOLWidget = async ()=>{
    try {
        // LOAD CSS:
        const isCSSLoaded = await handleLoadingCSS();
        if (!isCSSLoaded) throw new Error("CSS failed to load");
        // INITIALIZE FOL WIDGET:
        await initializeFOLWidget();
        // THEN SHOW THE WIDGET:
        const widgetContainer = document.getElementById("fol-widget");
        widgetContainer.classList.remove($g3aVv["hidden"]);
        widgetContainer.removeAttribute("id");
    } catch (error) {
        console.error(error);
    }
};
renderFOLWidget();

});
parcelRegister("gbMqE", function(module, exports) {
module.exports = "<svg width=\"75\" height=\"75\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"m11.094 64.09 8.61-9.402L8.526 44.481c-1.007-.955-1.108-2.514-.151-3.57l24.92-27.15c.958-1.006 2.518-1.107 3.575-.151l36.803 33.737c5.438-19.96-6.343-40.525-26.33-46.006-19.988-5.48-40.58 6.336-46.067 26.297-3.474 13.073.252 26.95 9.817 36.453Z\" fill=\"#731F4A\"/><path d=\"M33.347 13.769 8.426 40.92c-.957 1.006-.856 2.615.15 3.57l11.177 10.207 16.111-17.548c.957-1.005 2.517-1.106 3.575-.15l26.884 24.636c3.474-4.173 6.042-9 7.452-14.229L36.972 13.618c-1.108-.905-2.669-.855-3.625.151Z\" fill=\"#F0627F\"/><path d=\"M35.814 37.145 19.703 54.693l-8.61 9.402c14.651 14.582 38.415 14.531 53.015-.1.755-.754 1.46-1.559 2.165-2.363L39.388 36.995c-1.007-.956-2.618-.855-3.574.15Z\" fill=\"#E3B364\"/></svg>";

});

parcelRegister("4hQzZ", function(module, exports) {
module.exports = "<svg width=\"75\" height=\"75\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"m73.11 45.472-35.53-32.6-.004-.004c-1.475-1.333-3.652-1.18-4.967.204l-.007.006-.006.007-24.898 27.15-.005.005c-1.334 1.474-1.18 3.652.204 4.967l.007.006.007.007 10.428 9.531-7.212 7.885c-8.76-9.22-12.107-22.347-8.82-34.738C7.648 8.468 27.672-3.027 47.104 2.306 66.004 7.493 77.357 26.562 73.11 45.472Z\" fill=\"#731F4A\" stroke=\"#731F4A\" stroke-width=\"2\"/><path d=\"m9.208 41.61.007-.006.006-.007 24.892-27.143c.56-.585 1.507-.659 2.238-.077L72.646 47.73c-1.303 4.526-3.502 8.735-6.425 12.452L40.145 36.263l-.006-.005c-1.474-1.333-3.651-1.18-4.966.204l-.007.006-.005.007-15.422 16.812L9.317 43.76c-.631-.606-.653-1.578-.109-2.15Z\" fill=\"#F0627F\" stroke=\"#731F4A\" stroke-width=\"2\"/><path d=\"m63.41 63.284-.001.001C49.437 77.3 26.836 77.57 12.544 64.051l7.945-8.685v-.001l16.09-17.54c.605-.631 1.579-.653 2.152-.109l.006.006.006.006 26.14 23.975a35.822 35.822 0 0 1-1.473 1.581Z\" fill=\"#E3B364\" stroke=\"#731F4A\" stroke-width=\"2\"/><path d=\"M73.433 37.5c0 19.883-16.104 36-35.967 36C17.604 73.5 1.5 57.383 1.5 37.5c0-19.884 16.104-36 35.966-36 19.863 0 35.967 16.116 35.967 36Z\" fill=\"#F78CA2\" stroke=\"#731F4A\" stroke-width=\"3\"/><path d=\"M26.091 23c-.349 0-.698.131-.964.395l-2.727 2.69a1.331 1.331 0 0 0 0 1.903l9.945 9.812-9.945 9.812a1.331 1.331 0 0 0 0 1.902l2.727 2.691a1.375 1.375 0 0 0 1.928 0L37 42.393l9.945 9.812a1.375 1.375 0 0 0 1.928 0l2.727-2.69a1.331 1.331 0 0 0 0-1.903L41.655 37.8l9.945-9.812a1.331 1.331 0 0 0 0-1.903l-2.727-2.69a1.375 1.375 0 0 0-1.928 0L37 33.206l-9.945-9.813a1.368 1.368 0 0 0-.964-.394Z\" fill=\"#731F4A\"/></svg>";

});

parcelRegister("fSvBw", function(module, exports) {
module.exports = "<svg fill=\"#515151\" height=\"12\" width=\"12\" version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1792 1792\" xml:space=\"preserve\"><path d=\"m1082.2 896.6 410.2-410c51.5-51.5 51.5-134.6 0-186.1s-134.6-51.5-186.1 0l-410.2 410L486 300.4c-51.5-51.5-134.6-51.5-186.1 0s-51.5 134.6 0 186.1l410.2 410-410.2 410c-51.5 51.5-51.5 134.6 0 186.1 51.6 51.5 135 51.5 186.1 0l410.2-410 410.2 410c51.5 51.5 134.6 51.5 186.1 0 51.1-51.5 51.1-134.6-.5-186.2l-409.8-409.8z\"/></svg>";

});

parcelRegister("g3aVv", function(module, exports) {

$parcel$export(module.exports, "background-container", () => $baf566f20fd57d14$export$51b48b418f9ae0cb, (v) => $baf566f20fd57d14$export$51b48b418f9ae0cb = v);
$parcel$export(module.exports, "button-container", () => $baf566f20fd57d14$export$4f7a98834621a1a, (v) => $baf566f20fd57d14$export$4f7a98834621a1a = v);
$parcel$export(module.exports, "button-text-container", () => $baf566f20fd57d14$export$6d80edbb02241747, (v) => $baf566f20fd57d14$export$6d80edbb02241747 = v);
$parcel$export(module.exports, "close-widget-icon", () => $baf566f20fd57d14$export$4a29c5957276401b, (v) => $baf566f20fd57d14$export$4a29c5957276401b = v);
$parcel$export(module.exports, "fol-widget", () => $baf566f20fd57d14$export$8500ba216e017722, (v) => $baf566f20fd57d14$export$8500ba216e017722 = v);
$parcel$export(module.exports, "font-bold", () => $baf566f20fd57d14$export$cfed76132a7272da, (v) => $baf566f20fd57d14$export$cfed76132a7272da = v);
$parcel$export(module.exports, "font-regular", () => $baf566f20fd57d14$export$b8b98b6c2250c4d4, (v) => $baf566f20fd57d14$export$b8b98b6c2250c4d4 = v);
$parcel$export(module.exports, "hidden", () => $baf566f20fd57d14$export$73920f18ca706874, (v) => $baf566f20fd57d14$export$73920f18ca706874 = v);
$parcel$export(module.exports, "hide-widget-button-container", () => $baf566f20fd57d14$export$90ccbb3eac8ddc2f, (v) => $baf566f20fd57d14$export$90ccbb3eac8ddc2f = v);
$parcel$export(module.exports, "icon", () => $baf566f20fd57d14$export$1ca1ec8b29a4ce27, (v) => $baf566f20fd57d14$export$1ca1ec8b29a4ce27 = v);
$parcel$export(module.exports, "iframe-container", () => $baf566f20fd57d14$export$5c7b904e62ea11ff, (v) => $baf566f20fd57d14$export$5c7b904e62ea11ff = v);
$parcel$export(module.exports, "loading", () => $baf566f20fd57d14$export$46c1c92549715335, (v) => $baf566f20fd57d14$export$46c1c92549715335 = v);
var $baf566f20fd57d14$export$51b48b418f9ae0cb;
var $baf566f20fd57d14$export$4f7a98834621a1a;
var $baf566f20fd57d14$export$6d80edbb02241747;
var $baf566f20fd57d14$export$4a29c5957276401b;
var $baf566f20fd57d14$export$8500ba216e017722;
var $baf566f20fd57d14$export$cfed76132a7272da;
var $baf566f20fd57d14$export$b8b98b6c2250c4d4;
var $baf566f20fd57d14$export$73920f18ca706874;
var $baf566f20fd57d14$export$90ccbb3eac8ddc2f;
var $baf566f20fd57d14$export$1ca1ec8b29a4ce27;
var $baf566f20fd57d14$export$5c7b904e62ea11ff;
var $baf566f20fd57d14$export$46c1c92549715335;
$baf566f20fd57d14$export$51b48b418f9ae0cb = `K0b1SW_background-container`;
$baf566f20fd57d14$export$4f7a98834621a1a = `K0b1SW_button-container`;
$baf566f20fd57d14$export$6d80edbb02241747 = `K0b1SW_button-text-container`;
$baf566f20fd57d14$export$4a29c5957276401b = `K0b1SW_close-widget-icon`;
$baf566f20fd57d14$export$8500ba216e017722 = `K0b1SW_fol-widget`;
$baf566f20fd57d14$export$cfed76132a7272da = `K0b1SW_font-bold`;
$baf566f20fd57d14$export$b8b98b6c2250c4d4 = `K0b1SW_font-regular`;
$baf566f20fd57d14$export$73920f18ca706874 = `K0b1SW_hidden`;
$baf566f20fd57d14$export$90ccbb3eac8ddc2f = `K0b1SW_hide-widget-button-container`;
$baf566f20fd57d14$export$1ca1ec8b29a4ce27 = `K0b1SW_icon`;
$baf566f20fd57d14$export$5c7b904e62ea11ff = `K0b1SW_iframe-container`;
$baf566f20fd57d14$export$46c1c92549715335 = `K0b1SW_loading`;

});



parcelRequire("0O13J");
})();
//# sourceMappingURL=main.js.map
